import { Divider, Form, Select } from 'antd';

import { PictureComponentV2 } from 'app/components/commons/PictureComponentV2/PictureComponentV2';
import type { RoomScrapped } from 'app/typings/autoInventory';
import type { ExtranetHotelRoom } from 'app/typings/core/extranet/hotel/rooms';

import styles from './RoomMappingRow.module.scss';

const { Option } = Select;

type RoomMappingRowProps = {
  room: ExtranetHotelRoom;
  roomIdx: number;
  bookingRooms: RoomScrapped[];
  isOptionDisabled: (bookingRoomId: number) => boolean;
};

export const RoomMappingRow = ({
  room,
  roomIdx,
  bookingRooms,
  isOptionDisabled,
}: RoomMappingRowProps) => {
  const form = Form.useFormInstance();

  const scrappedRoomId = Form.useWatch<number | undefined>([
    'roomMappings',
    roomIdx,
    'scrappedRoomId',
  ]);
  const scrappedRoomName = Form.useWatch<string | undefined>([
    'roomMappings',
    roomIdx,
    'scrappedRoomName',
  ]);

  const handleSelectChange = (value: number) => {
    const selectedRoom = bookingRooms.find((br) => br.roomId === value);

    form.setFieldValue(
      ['roomMappings', roomIdx, 'scrappedRoomName'],
      selectedRoom?.roomName
    );
  };

  const roomDisplayName = room.name ?? room.categoryName ?? '';

  const hasScrappedRoomId =
    scrappedRoomId !== undefined && scrappedRoomId !== null;
  const hasCurrentOption =
    hasScrappedRoomId &&
    bookingRooms.some((br) => br.roomId === scrappedRoomId);

  return (
    <div className={styles.roomMappingRow}>
      <div className={styles.staycationRoom}>
        {room.coverPicture && (
          <PictureComponentV2
            className={styles.roomImage}
            path={room.coverPicture.path}
          />
        )}
        <span className={styles.roomName}>{roomDisplayName}</span>
      </div>

      <Divider className={styles.dividerRoomMapping} />

      <Form.Item name={['roomMappings', roomIdx, 'scrappedRoomId']} noStyle>
        <Select
          className={styles.bookingSelect}
          placeholder="Select matching room"
          onChange={handleSelectChange}
        >
          {!hasCurrentOption && hasScrappedRoomId && (
            <Option value={scrappedRoomId}>
              {scrappedRoomName ?? scrappedRoomId}
            </Option>
          )}
          {bookingRooms.map((br) => (
            <Option
              key={br.roomId}
              value={br.roomId}
              disabled={isOptionDisabled(br.roomId)}
            >
              {br.roomName}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name={['roomMappings', roomIdx, 'staycationRoom']} hidden>
        <input />
      </Form.Item>

      <Form.Item name={['roomMappings', roomIdx, 'scrappedRoomName']} hidden>
        <input type="hidden" />
      </Form.Item>
    </div>
  );
};
